export const mobileMaxWidth = 768
export const tabletMaxWidth = 769
export const checkListSection = 'checkListSection'
export const generalSection = 'generalSection'

// 320px — 480px: Mobile devices.
// 481px — 768px: iPads, Tablets.
// 769px — 1024px: Small screens, laptops.
// 1025px — 1200px: Desktops, large screens.
// 1201px and more — Extra large screens, TV.